"use strict";

class SelectBroadcastCtrl {

    constructor($scope, $mdDialog, $rootScope, $state, broadcasts, target_date) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.target_date = target_date;
        this.broadcasts = this.filtered(broadcasts);
        this.$scope.broadcasts = this.broadcasts;

        this.$scope.cancel = () => {
            this.$mdDialog.cancel();
        };

        this.$scope.goToBroadcast = (broadcast) => {
            this.$scope.cancel();
            this.$state.go('rundown', {
                program: broadcast.program_id,
                broadcast: broadcast.id
            });
        };
    }

    filtered(broadcasts) {
        if (broadcasts === undefined) {
            broadcasts = this.broadcasts || undefined;
            if (broadcasts === undefined) return [];
        }

        return broadcasts.filter((b) => {
            let start = moment(b.start);
            if (start === undefined) return false;
            // Only the start day counts: a broadcast running until 00:00 stops on the next day,
            // and still has to be offered here (RM-158).
            return this.target_date.isSame(start, 'day');
        }).map((b) => {
          b.start = moment(b.start).format('LT');
          b.stop = moment(b.stop).format('LT');
          return b;
        }).sort((one, two) => (moment(one.start).valueOf() > moment(two.start).valueOf()) - (moment(one.start).valueOf() < moment(two.start).valueOf()));
    }
}

SelectBroadcastCtrl.$inject = ['$scope', '$mdDialog', '$rootScope', '$state', 'broadcasts', 'target_date'];

module.exports = SelectBroadcastCtrl;
